module.exports = __webpack_public_path__ + "img/dice-2.727fe8a0.svg";